"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconReply = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M8.33333333,7.5 L8.33333333,4.16666667 L2.5,10 L8.33333333,15.8333333 L8.33333333,12.4166667 C12.5,12.4166667 15.4166667,13.75 17.5,16.6666667 C16.6666667,12.5 14.1666667,8.33333333 8.33333333,7.5 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconReply')(IconReply);